export default __webpack_public_path__ + "static/media/section04.3049b908.jpg";